module.exports = __webpack_public_path__ + "img/background-study-assessment-team@2x.40ccf693.jpg";